import {isVisible} from "./bitmask";
import {PathType, PathTypesType} from "../constant/pathType";
import {PlacePathType} from "../constant/PlacePatyType";

export const setPathType = (pathType: number) : PathTypesType => {
    if(!isVisible(pathType,1)){
        if(isVisible(pathType,2)) return PathType["single_order"]
        else if(isVisible(pathType,0)) return PathType["single_review"]
        else if(isVisible(pathType,3)){
            if(isVisible(pathType,2)) return PathType["plusstore_order"]
            else return PathType["plusstore_productNumber"]
        }
        else return PathType["single_productNumber"]
    }else{
        if(isVisible(pathType,2)) return PathType["catalog_order"]
        else if(isVisible(pathType,0)) return PathType["catalog_review"]
        else return PathType["catalog_productNumber"]
    }
}
